export default __webpack_public_path__ + "img/demi-sec.asset.4ac30d42.png";